import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('progressStore', Object.keys(state)),
	...mapGetters('progressStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('progressStore', Object.keys(actions)),
	...mapMutations('progressStore', Object.keys(mutations))
};
